import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@metarouter-private/mr-mui';

import UncontrolledCodeEditor from 'app/components/UncontrolledCodeEditor';

import useEditorState from './useEditorState';
import SampleEventControls from './SampleEventControls';
import ManageSampleEventsModal from './ManageSampleEventsModal';

export default function InputEventEditorWithSamples({
  defaultValue,
  setValue,
  setHasValidInput,
  trackingEventName,
  errorMsg: externalErrorMsg,
}) {
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);

  const {
    currentValue,
    editorKey,
    errorMessage,
    selectedSampleEventId,
    onInputChange,
    onInputBlur,
    onSampleEventChange,
    loadSampleEvent,
  } = useEditorState({ defaultValue, setValue, setHasValidInput, trackingEventName });

  return (
    <Stack spacing={2}>
      <SampleEventControls
        currentValue={currentValue}
        selectedSampleEventId={selectedSampleEventId}
        loadSampleEvent={loadSampleEvent}
        onOpenManageModal={() => setIsManageModalOpen(true)}
      />

      <UncontrolledCodeEditor
        foldable
        key={editorKey}
        name="inputEvent"
        lang="json"
        errorMsg={errorMessage || externalErrorMsg}
        onBlur={onInputBlur}
        onChange={onInputChange}
        defaultValue={currentValue}
        rows={30}
      />

      <ManageSampleEventsModal
        open={isManageModalOpen}
        onClose={() => setIsManageModalOpen(false)}
        onSampleEventChange={onSampleEventChange}
      />
    </Stack>
  );
}

InputEventEditorWithSamples.propTypes = {
  defaultValue: PropTypes.string,
  errorMsg: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  setHasValidInput: PropTypes.func.isRequired,
  trackingEventName: PropTypes.string.isRequired,
};
